import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ContractsService } from '@api/contracts.service';
import { Subject, Subscription } from 'rxjs';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { ExtraServiceResponseData } from '@shared/model/extraservices.model';
import jalaliMoment = require('jalali-moment');

@Component({
  selector: 'app-view-request',
  templateUrl: './view-request.component.html',
  styleUrls: ['./view-request.component.scss'],
})
export class ViewRequestComponent implements OnInit {
  response;
  requestContract = [];
  requestDetail = [];
  baseUrl = environment.baseUrl;
  private subscription = new Subscription();
  extraServices: ExtraServiceResponseData[] = [];
  public requestDetailForm: FormGroup;
  requestId;
  providerId;

  constructor(
    private contractsService: ContractsService,
    private formBuilder: FormBuilder,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
  ) {
    this.requestDetailForm = this.formBuilder.group({
      selectedExtraServices: this.formBuilder.array([]),
    });
  }
  ngOnInit() {
    const url = this.router.url;
    this.requestId = this.activatedRoute.snapshot.params.requestId;
    this.providerId = this.activatedRoute.snapshot.params.providerId;
    this.getInitialData();
  }

  getInitialData() {
    this.subscription = this.contractsService.getContractRequest(this.requestId).subscribe((res: any) => {
      this.requestDetail.push(res);
      this.requestDetail[0].arriveDate = jalaliMoment( this.requestDetail[0].arriveDate).format('jYYYY/jMM/jDD hh:mm');
      this.requestDetail[0].departureDate = jalaliMoment( this.requestDetail[0].departureDate).format('jYYYY/jMM/jDD hh:mm');
      this.getInitialValue(res);
    });
  }
  createServices(): FormGroup {
    return this.formBuilder.group({
      id: Number,
      enTitle: String,
      faTitle: String,
      isChecked: Boolean,
      oldValue: Boolean,
      newValue: Boolean,
    });
  }
  getImageUrl(url: string) {
    if (url) {
      return `${this.baseUrl}/${url}`;
    }
    if (!url) {
      return 'assets/img/no-image.jpg';
    }
  }
  getInitialValue(response) {
    this.response = response;
    if (this.response) {
      const selectedExtraService = this.response.selectedExtraServices.value;
      const express = response?.isExpress ? 1 : 0;
      const document = response?.isDocument ? 1 : 0;
      this.http.get(
        `${environment.baseUrl}/api/v1/base-info/extra-services?serviceType=${response?.serviceTypeId}&express=${express}&document=${document}`)
        .subscribe((res: any) => {
          this.extraServices = res.data;
          if (this.response.isDocument) {
            for (let i = 0; i < this.extraServices.length; i++) {
              if (this.extraServices[i]?.enTitle === 'Inspection services') {
                this.extraServices.splice(i, 1);
              }
              if (this.extraServices[i]?.enTitle === 'Obtaining a license') {
                this.extraServices.splice(i, 1);
              }
              if (this.extraServices[i]?.enTitle === 'Warehousing') {
                this.extraServices.splice(i, 1);
              }
              if (this.extraServices[i]?.enTitle === 'Payment services') {
                this.extraServices.splice(i, 1);
              }
              if (this.extraServices[i]?.enTitle === 'sourcing and Purchase order') {
                this.extraServices.splice(i, 1);
              }
              if (this.extraServices[i]?.enTitle === 'order registration') {
                this.extraServices.splice(i, 1);
              }
            }
          }
          this.extraServices.map((_: any) => {
            _.isChecked = false;
            return _;
          });
          const selectedExtraServiceId = selectedExtraService.map((_) => _.id);
          this.extraServices.map((_) => {
            selectedExtraServiceId.includes(_.id)
              ? (_.isChecked = true)
              : (_.isChecked = false);
            return _;
          });
          const formServices = this.requestDetailForm.get(
            'selectedExtraServices'
          ) as FormArray;
          this.extraServices.map((item, i) => {
            formServices.push(this.createServices());
            formServices.controls[i].patchValue(item);
          });
        });
    }

  }
}
